/**
 * StoreBar - Saga
 */

import { call, put, takeLatest } from '@redux-saga/core/effects';
import * as types from '../../actions/storeBar/storeBarActionTypes';
import * as actions from '../../actions/storeBar/storeBarActions';
import reservationService from '../../services/reservationService';
import { CommonClubListResponse } from '../../../components/Common/StoreBar/StoreBar.types';

/**
 * 获取共通店铺列表
 */
function* fetchCommonClubListSaga(action: ReturnType<typeof actions.fetchCommonClubListRequest>): Generator<unknown> {
  try {
    const { payload: memberId } = action;
    const clubId = Number(sessionStorage.getItem('shopId'));
    console.log('[storeBarSaga] 共通店舗リスト取得開始 - member_id:', memberId, 'club_id:', clubId);

    // 调用API
    const response: any = yield call(() => reservationService().getCommonClubList(memberId, clubId));

    console.log('[storeBarSaga] APIレスポンス:', response);

    const { data } = response;
    if (data.result === 0) {
      const responseData: CommonClubListResponse = data;

      // 分别提取三个列表
      const belongClubs = responseData.belong_club_list || [];
      const favoriteClubs = responseData.favorite_club_list || [];
      const otherClubs = responseData.other_club_list || [];

      console.log('[storeBarSaga] 所属店舗リスト:', belongClubs);
      console.log('[storeBarSaga] お気に入りリスト:', favoriteClubs);
      console.log('[storeBarSaga] その他の店舗リスト:', otherClubs);

      yield put(actions.fetchCommonClubListSuccess(belongClubs, favoriteClubs, otherClubs));

      console.log('[storeBarSaga] 共通店舗リスト取得成功');
    } else {
      throw new Error('API returned error result');
    }
  } catch (error: any) {
    console.error('[storeBarSaga] 共通店舗リスト取得エラー:', error);
    yield put(actions.fetchCommonClubListFailure(error.message || '店舗リストの取得に失敗しました'));
  }
}

/**
 * Root Saga
 */
export function* storeBarSaga(): Generator<unknown> {
  yield takeLatest(types.FETCH_COMMON_CLUB_LIST_REQUEST, fetchCommonClubListSaga);
}

export default storeBarSaga;
